module.exports = __webpack_public_path__ + "media/images/front/icons/makers-508374614a0dd2e9345c66bb662fe7cb.png";